import React from 'react';
import ProjectTableHeader from './ProjectTableHeader';
import ProjectTableRow from './ProjectTableRow';

/**
 * Table component for ProjectList, wrapping header and rows.
 * 
 * @param {Object} props
 * @param {Array} props.list
 * @param {boolean} props.showBulk
 * @param {Object} props.globalPermissions
 * @param {Array} props.selectedProjectIds
 * @param {Function} props.setSelectedProjectIds
 * @param {Function} props.handleSort
 * @param {Object} props.sortConfig
 * @param {Function} props.onProjectSelect
 * @param {Function} props.setSelectedProject
 * @param {Function} props.setProjectMode
 * @param {Function} props.setShowProjectModal
 * @param {Function} props.setFocusedProject
 * @param {Function} props.setViewMode
 * @param {Function} props.handleDeleteProject
 * @param {string} props.variant
 */
export default function ProjectTable({
    list,
    showBulk,
    globalPermissions,
    selectedProjectIds,
    setSelectedProjectIds,
    handleSort,
    sortConfig,
    onProjectSelect,
    setSelectedProject,
    setProjectMode,
    setShowProjectModal,
    setFocusedProject,
    setViewMode,
    handleDeleteProject,
    handleRestoreProject,
    handleHardDelete,
    isTrashView,
    variant
}) {
    return (
        <div className="projects-table-wrapper">
            <table className="projects-table">
                <ProjectTableHeader 
                    showBulk={showBulk}
                    globalPermissions={globalPermissions}
                    list={list}
                    selectedProjectIds={selectedProjectIds}
                    setSelectedProjectIds={setSelectedProjectIds}
                    handleSort={handleSort}
                    sortConfig={sortConfig}
                />
                <tbody>
                    {list.map(p => (
                        <ProjectTableRow 
                            key={p.id}
                            project={p}
                            showBulk={showBulk}
                            globalPermissions={globalPermissions}
                            selectedProjectIds={selectedProjectIds}
                            setSelectedProjectIds={setSelectedProjectIds}
                            onProjectSelect={onProjectSelect}
                            setSelectedProject={setSelectedProject}
                            setProjectMode={setProjectMode}
                            setShowProjectModal={setShowProjectModal}
                            setFocusedProject={setFocusedProject}
                            setViewMode={setViewMode}
                            handleDeleteProject={handleDeleteProject}
                            handleRestoreProject={handleRestoreProject}
                            handleHardDelete={handleHardDelete}
                            isTrashView={isTrashView}
                            variant={variant}
                        />
                    ))}
                    {list.length === 0 && (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>Keine Projekte gefunden.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
